var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "14px",
    viewBox: "0 0 26 14",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0.25L0 0.25",
    id: "Line-2",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0.25L0 0.25",
    transform: "translate(0 6)",
    id: "Line-2",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0.25L0 0.25",
    transform: "translate(0 12)",
    id: "Line-2",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeLinecap: "square"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBurger);
export default __webpack_public_path__ + "static/media/menu_burger.1ff1ab63.svg";
export { ForwardRef as ReactComponent };